import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown, MessageCircle } from "lucide-react";
import { useState } from "react";
import { WA_LINK } from "@/lib/site";

const HERO_FALLBACK =
  "https://images.unsplash.com/photo-1676972582823-dfd86a3f6c18?auto=format&fit=crop&w=1920&q=80";

const LINES = [
  { text: "SEU PRÉDIO", cls: "text-white" },
  { text: "MERECE NASCER", cls: "text-white" },
  { text: "DE NOVO.", cls: "text-krono" },
];

export const Hero = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], [0, 220]);
  const [imgError, setImgError] = useState(false);

  return (
    <section id="top" data-testid="hero-section" className="relative flex min-h-screen items-end overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 -bottom-56">
        <img
          src={imgError ? HERO_FALLBACK : "/assets/hero-sunset.png"}
          onError={() => setImgError(true)}
          alt="Pintor em rope access ao pôr do sol em São Paulo"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/30" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-20 pt-40">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 1 }}
          className="mb-6 font-mono text-xs uppercase tracking-[0.3em] text-krono"
          data-testid="hero-eyebrow"
        >
          Pintura predial em altura — Rope Access — São Paulo
        </motion.p>
        <h1 className="font-display text-5xl font-black uppercase leading-[0.95] tracking-tighter sm:text-6xl lg:text-7xl">
          {LINES.map((line, i) => (
            <span key={line.text} className="block overflow-hidden pb-1">
              <motion.span
                className={`block ${line.cls}`}
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ delay: 0.15 + i * 0.14, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`hero-headline-line-${i + 1}`}
              >
                {line.text}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center"
        >
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-whatsapp"
            className="group inline-flex items-center gap-3 bg-krono px-8 py-4 font-mono text-sm font-bold uppercase tracking-[0.15em] text-black transition-colors hover:bg-krono-hover"
          >
            <MessageCircle className="h-4 w-4 transition-transform group-hover:-rotate-12" />
            Orçamento gratuito no WhatsApp
          </a>
          <a
            href="#servicos"
            data-testid="hero-cta-services"
            className="inline-flex items-center gap-3 border border-white/20 px-8 py-4 font-mono text-sm uppercase tracking-[0.15em] text-white/80 transition-colors hover:border-krono hover:text-krono"
          >
            <ArrowDown className="h-4 w-4" />
            Ver serviços
          </a>
        </motion.div>
      </div>
    </section>
  );
};
